export function formatCurrency(cents: number): string {
    return `R$ ${(cents / 100).toFixed(0)}`;
}
